module.exports = __webpack_public_path__ + "static/media/wat_is_ifrs.6f9375e6.png";